module.exports = __webpack_public_path__ + "static/media/listing-page-mahabaleshwar.30226e35.webp";